var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-space-between white--text font-weight-light px-6 py-1",staticStyle:{"background-color":"#b40200"}},[_c('span',{staticStyle:{"font-size":"9px"}},[_vm._v(_vm._s(_vm.$t("chatSidebar.offline")))])])}
var staticRenderFns = []

export { render, staticRenderFns }